import React, { ReactNode, use, useContext, useEffect, useState } from 'react';
import axios, { AxiosStatic } from 'axios';
import { SessionIASMA, UserIASMA } from 'iasma-datatypes';
import { useNavigate } from "react-router-dom";
import { AuthContext, AuthContextType } from './AuthContext';
import { DOMAIN_API, SESSION_NAME } from '../../constants';

const API_URL = DOMAIN_API + '/api/auth'

interface AuthProviderProps {
	children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
	const navigate = useNavigate();
	const [session, setSession] = useState<SessionIASMA | undefined>(undefined);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		// Check for stored user on mount
		const storedSession = localStorage.getItem(SESSION_NAME);
		if (storedSession) {
			let newSession = JSON.parse(storedSession); 
			setSession(newSession);
		}
		setIsLoading(false);
	}, []);

	useEffect(() => {
		// console.log('Auth: session changed:', session);
		if (session) {
			// console.log('Auth: session ExpiredAt:', session?.ExpiredAt);
			localStorage.setItem(SESSION_NAME, JSON.stringify(session));
		} else {
			localStorage.removeItem(SESSION_NAME);
		}
	}, [session]);

	const signin = async (data: any) => {
		// console.log('signin:data:', data);
		// console.log('signin:API_URL:', API_URL);
		setIsLoading(true);
		try {
			const response = await axios.post(API_URL + "/signin", data);
			// console.log("signin:response.data", response.data)
			if (response.data.AccessToken) {
				setSession(response.data);
				console.log("x-version-frontend", response.headers["x-version-frontend"]);
			}

		} catch (error) {
			throw new Error('Auth: Signin failed');
		} finally {
			setIsLoading(false);
		}
	};

	const signout = async () => {
		// console.log('signout:API_URL:', API_URL);
		navigate("/")
		setAccessToken(axios);
		await axios.post(API_URL + "/signout");
		setSession(undefined);
	};

	function setAccessToken(axios: AxiosStatic) {
		// console.log('Auth: session ExpiredAt:', session?.ExpiredAt);
		axios.defaults.headers.common['x-access-token'] = session?.AccessToken;
	};

	const hasRole = (role: number) => {
		let result = false;
		if (session && session.Roles)
			result = session.Roles.indexOf(role) >= 0;		
		return result;
	}

	const getRoles = async (id?: number) => {
		if (id)
			return axios.get(API_URL + `/roles/${id}`);
		else
			return axios.get(API_URL + '/roles');
	}

	const saveRoles = async (data: any) => {
		await axios.patch(API_URL + '/roles', data)
	}

	const value: AuthContextType = {
		isLoading,
		setIsLoading,
		session,
		signin,
		signout,
		setToken: setAccessToken,
		hasRole,
		getRoles,
		saveRoles
	};

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuthContext = () => useContext(AuthContext);